export default __webpack_public_path__ + "static/media/11.ce2458c9.png";